<template>
  <div
    class="modal"
    :class="{ 'is-active': active, 'is-small': isSmall, 'no-margin': noMargin }"
  >
    <div class="modal-background" @click.stop="active = false"></div>
    <div class="modal-card">
      <section class="modal-card-body">
        <button
          class="button is-text is-close icon-close"
          @click="active = false"
        ></button>
        <p v-if="title" class="modal-card-title">{{ title }}</p>
        <slot></slot>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppModal',
  props: {
    value: {},
    title: {},
    isSmall: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    };
  },
  watch: {
    active() {
      if (!this.active) {
        this.$emit('close');
      }
      if (this.value != this.active) {
        this.$emit('input', this.active);
      }
      if (this.active) {
        document.getElementsByTagName('html')[0].classList.add('is-clipped');
      } else {
        document.getElementsByTagName('html')[0].classList.remove('is-clipped');
      }
    },
    value: {
      immediate: true,
      handler() {
        if (this.value != this.active) {
          this.active = this.value;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.modal {
  &.is-small {
    .modal-card {
      width: 50%;
    }
  }

  &.no-margin {
    .modal-card-body {
      padding: 2.2rem 15px;
    }
  }

  .modal-card {
    max-width: 1200px;
    width: 90%;

    /*
    @include widescreen {
      width: 90%;
    }
    @include fullhd {
      width: 90%;
    }*/
  }
  .modal-card-body {
    overflow-x: hidden !important;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(112, 112, 112, 0.1) 100%
    );
    .modal-card-title {
      padding-bottom: 4.5rem;
    }
    .button.is-close {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0;
      line-height: 1;
      height: 20px;
      font-size: 20px;
      z-index: 100;
    }
  }
}
</style>
